import { ModelViewer } from "./ModelViewer";
import queryString from "query-string";
// import serialize from 'form-serialize';
import Glide from "@glidejs/glide";

class Product {
  constructor() {
    this.postMetaUpdating = false;
    this.product = {
      content: document.querySelector(".product-single__content"),
      id: document.querySelector(".product-single").dataset.id,
      liked: document.querySelector("[data-liked]").dataset.liked == "true"
    };

    document.querySelectorAll(".product-action").forEach(el => {
      el.addEventListener("click", e => this.updatePostMeta(el, e));
    });

    this.shareOptionsActive = false;

    document
      .querySelector(".product-action__share")
      .addEventListener("click", e => {
        e.stopPropagation();
        this.toggleShareOptions(true);
      });

    document.addEventListener(
      "click",
      e => {
        e.stopPropagation();
        // If the click happened inside the the container, bail
        if (!event.target.closest(".product-share")) {
          this.toggleShareOptions(false);
        }
      },
      false
    );

    document
      .querySelector(".product-share__close")
      .addEventListener("click", e => {
        e.stopPropagation();
        this.toggleShareOptions(false);
      });

    this.actionForm = document.querySelector("form.action-select");
    this.actionButton = document.querySelector(".product-action__buy");

    this.actionForm.addEventListener("change", e => {
      var checked = this.actionForm.querySelector("input:checked");
      var label = checked.parentElement.querySelector("[data-label]").dataset
        .label;

      this.actionButton.querySelector("span").innerHTML = label;
    });

    this.actionButton.addEventListener("click", e =>
      this.onActionButtonClick(e)
    );

    // this.setFixed();

    if (document.querySelector(".glide--product") != null) {
      this.glideInstance = new Glide(".glide--product", {
        swipeThreshold: 20,
        type: "slider",
        gap: 0
      });

      this.glideInstance.mount();
    }

    document.querySelectorAll(".files__list .file").forEach(el => {
      el.addEventListener("click", e => {
        const amount = el.querySelector(".file__downloads span");
        amount.innerHTML = parseInt(amount.textContent) + 1;
      });
    });

    document
      .querySelector(".file__download-all")
      .addEventListener("click", e => {
        const amount = document.querySelector(".product-meta__downloads span");
        amount.innerHTML = parseInt(amount.textContent) + 1;
      });
  }

  toggleShareOptions(active) {
    if (typeof active == "undefined") {
      this.shareOptionsActive = !this.shareOptionsActive;
    } else {
      this.shareOptionsActive = active;
    }

    this.shareOptions = document.querySelector(".product-share");

    if (!this.shareOptionsActive) {
      document.body.classList.remove("product-share-active");
    } else {
      document.body.classList.add("product-share-active");
    }
  }

  onActionButtonClick(e) {
    e.preventDefault();
    var action = this.actionForm.querySelector("input:checked").value;
  }

  // Fix product content on the right side when on desktop
  setFixed() {
    var p = this.product.content;
    var dimensions = this.product.content.getBoundingClientRect();

    p.style.position = "fixed";
    p.style.width = dimensions.width + "px";
    p.style.height = dimensions.height + "px";
    p.style.left = dimensions.left + "px";
    p.style.right = dimensions.right + "px";
  }

  // Updates a meta field
  updatePostMeta(el, e) {
    if (this.postMetaUpdating) return;

    this.postMetaUpdating = true;

    // e.preventDefault();
    var meta_key = el.dataset.metaValue;
    var currentValueEl = document.querySelector(`.product-meta__${meta_key}`);
    var currentValue = currentValueEl.querySelector("span").innerHTML;

    if (meta_key == "likes" && this.product.liked) {
      meta_key = "dislikes";
      var value = parseInt(currentValue) - 1;
      el.dataset.liked = "false";
      this.product.liked = false;
    } else {
      var value = parseInt(currentValue) + 1;
      el.dataset.liked = "true";
      this.product.liked = true;
    }

    currentValueEl.querySelector("span").innerHTML = value;

    var body = queryString.stringify({
      action: "update_post_meta_ajax",
      meta_key: meta_key,
      post_id: this.product.id
    });

    fetch(local.ajaxurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      body: body
    })
      .then(res => res.json())
      .then(res => {
        if (!res.success) {
          console.error("Request failed");
          this.postMetaUpdating = false;
          return;
        }

        currentValueEl.querySelector("span").innerHTML = res.newValue;
        this.postMetaUpdating = false;
      })
      .catch(err => console.error(err));
  }
}

export { Product };
